import { z } from 'zod';
export const ALERT_TYPES = [
    'battery_removal', 'cap_replacement', 'clock_battery',
    'fan_replacement', 'psu_recap', 'floppy_belt', 'custom',
];
export const ALERT_SEVERITIES = ['critical', 'high', 'medium', 'low'];
export const createMaintenanceAlertSchema = z.object({
    alertType: z.enum(ALERT_TYPES),
    severity: z.enum(ALERT_SEVERITIES).default('medium'),
    title: z.string().min(1).max(255),
    description: z.string().max(2000).optional().default(''),
});
//# sourceMappingURL=maintenance.js.map